// @flow
import { Fragment } from 'react';
import Carousel from '../TextOnly';
import { style, media } from 'typestyle';
import * as csx from 'csstips';

import ExternalElementPopup from '../../popups/ExternalElementPopup';

const contentStyles = style(
  csx.horizontal,
  media(
    { minWidth: 0, maxWidth: 500 },
    {
      ...csx.vertical,
      flexDirection: 'column',
      'article:last-of-type': {
        marginTop: 22
      }
    }
  ),
  media(
    { minWidth: 501 },
    {
      'article:last-of-type': {
        marginLeft: 20,
        flex: '0 0 55%'
      }
    }
  )
);

const items = [
  {
    headerText: 'FL',
    text: `
      <article>
        <h2>Flawless:</h2>
        <p class="no-bottom-margin">No inclusions or blemishes are visible to a skilled grader using 10x magnification.</p>
      </article>
      <article>
        <h2>Comments:</h2>
        <p class="no-bottom-margin">Extremely rare, less than 1 in 5000 jewelry quality diamonds are rated FL.</p>
      </article>
    `
  },
  {
    headerText: 'IF',
    text: `
      <article>
        <h2>Internally Flawless:</h2>
        <p class="no-bottom-margin">No inclusions, only blemishes are visible to a skilled grader using 10x magnification.</p>
      </article>
      <article>
        <h2>Comments:</h2>
        <p class="no-bottom-margin">FL and IF diamonds appear identical unless viewed under 10x magnification by a skilled grader. Less than 3% of jewelry quality diamonds are rated IF.</p>
      </article>
    `
  },
  {
    headerText: 'VVS1 - VVS2',
    component: (
      <Fragment>
        <article>
          <h2>Very, Very Slightly Included:</h2>
          <p className='no-bottom-margin'>
            Inclusions are difficult for a skilled grader to see under 10x
            magnification.
          </p>
        </article>
        <article>
          <h2>Comments:</h2>
          <p className='no-bottom-margin'>
            VVS1 inclusions are typically only visible from the{' '}
            <span
              className='text-link text-underline'
              data-popup='diamond-clarity-carousel--pavilion-1'
              role='button'
              tabIndex='0'
            >
              pavilion
            </span>
            , while VVS2 inclusions are visible from the{' '}
            <span
              className='text-link text-underline'
              data-popup='diamond-clarity-carousel--crown-1'
              role='button'
              tabIndex='0'
            >
              crown
            </span>
            . In each, the inclusions are invisible to the eye, appearing
            identical to the higher grades unless viewed under 10x magnification
            by a skilled grader.
          </p>
          <ExternalElementPopup
            name='Pavilion'
            selector='diamond-clarity-carousel--pavilion-1'
          />
          <ExternalElementPopup
            name='Crown'
            selector='diamond-clarity-carousel--crown-1'
          />
        </article>
      </Fragment>
    )
  },
  {
    headerText: 'VS1 - VS2',
    text: `
      <article>
        <h2>Very Slightly Included:</h2>
        <p class="no-bottom-margin">Inclusions are clearly visible under 10x magnification but can be characterized as minor.</p>
      </article>
      <article>
        <h2>Comments:</h2>
        <p class="no-bottom-margin">Inclusions are not visible to the naked eye. Perhaps 1 in 100 untrained observers can detect VS2 inclusions with the naked eye, on close inspection under ideal conditions.</p>
      </article>
    `
  },
  {
    headerText: 'SI1 - SI2',
    text: `
      <article>
        <h2>Slightly Included:</h2>
        <p class="no-bottom-margin">Inclusions are noticeable to a skilled grader using 10x magnification.</p>
      </article>
      <article>
        <h2>Comments:</h2>
        <p class="no-bottom-margin">SI1 is the lowest grade with flaws often invisible to the naked eye. SI2 inclusions are usually visible to the naked eye, although they will require close inspection.</p>
      </article>
    `
  },
  {
    headerText: 'I1 - I3',
    text: `
      <article>
        <h2>Included:</h2>
        <p class="no-bottom-margin">Inclusions are obvious under 10x magnification and may affect transparency and brilliance.</p>
      </article>
      <article>
        <h2>Comments:</h2>
        <p>I1 diamonds have inclusions that are almost always visible to the naked eye.</p>
        <p class="no-bottom-margin">Because I2-I3 diamonds have prounounced inclusions, and in the case of I3 may even affect the diamond's durability, they are not offered by Lumera.</p>
      </article>
    `
  }
];

export default (props: Object) => {
  return (
    <Carousel
      {...props}
      items={items}
      textColor='#7f7f7f'
      textAlign='left'
      contentClassName={contentStyles}
      contentStyles={{
        minHeight: 220
      }}
    />
  );
};
